import { RolesState, State } from '../configure-store';
import { Role } from '../../types/roles';

export const getRoles = (state: State): RolesState => state.roles;

export const getAssignableRoles = (state: State, allowedRoles?: string[]): RolesState => state.roles.filter(role => !role.deprecated || allowedRoles.includes(role.id));

export const getOrBuildRoleByRoleKey = (roles: Role[], role: string): Role => {
    return roles.find(_role => _role.id === role);
};

export const getRoleTitle = (state: State, roleId: string): string =>
  getRoles(state)?.find(role => role.id === roleId)?.title;

export const getRoleTitles = (state: State, roleIds: string[]): string[] =>
  getRoles(state)?.filter(role => roleIds.includes(role.id)).map(role => role.title);

export const getRoleNumOfScopes = (state: State, roleId: string): number => getRoles(state)?.find(role => role.id === roleId)?.scopes?.length;
